export const DropHeading = ({ text, as: Tag = "h2", className = "", testId }) => (
  <Tag data-testid={testId} className={`font-head font-semibold lowercase tracking-tight ${className}`}>
    <span className="inline-block align-baseline text-[2.5em] leading-[0.6]">{text[0]}</span>
    {text.slice(1)}
  </Tag>
);
